import React from 'react';

import PropTypes from 'prop-types';

import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandList,
} from '@/components/ui/command';
import ClearFiltersButton from './ClearFiltersButton';

const FilterSubMenu = ({
  activeFilters,
  children,
  emptyMessage,
  onClear,
  searchPlaceholder,
}) => (
  <Command className="[&_[cmdk-input-wrapper]]:h-8 [&_[cmdk-item]]:py-1">
    <CommandInput placeholder={searchPlaceholder} />

    <CommandList>
      <CommandEmpty>{emptyMessage}</CommandEmpty>
      {children}
      {activeFilters.length > 0 && <ClearFiltersButton onClear={onClear} />}
    </CommandList>
  </Command>
);

FilterSubMenu.propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
  emptyMessage: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
};

export default FilterSubMenu;
